var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import forgotPassword from '../../requests/authentication/forgotPassword';
/**
 *
 */
var ForgotPasswordCommand = /** @class */ (function (_super) {
    __extends(ForgotPasswordCommand, _super);
    function ForgotPasswordCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param email
     */
    ForgotPasswordCommand.prototype.execute = function (email) {
        //
        var promise = forgotPassword(email);
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    /**
     *
     * @param response
     */
    ForgotPasswordCommand.prototype.then = function (response) {
    };
    ForgotPasswordCommand.prototype.catch = function (error) {
    };
    return ForgotPasswordCommand;
}(Command));
export default ForgotPasswordCommand;
